import _ from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CartSection from "../../components/Cart/CartSection";
import Page from "../../finwell/pages/Page";
import { clickStreamUser } from "../../utils/AppUtils";
import Loader from "../../components/Loader/Loader";
import CartB2cSection from "../../components/b2cComponents/CartB2c";
import CartSectionComponent from "../../components/NewDesign/CartPage/CartSectionComponent";
import { getActiveHeader } from "../../redux/home/actions";

const CartPageB2c = () => {

    const dispatch = useDispatch();
    const auth = useSelector(state => state.auth);
    const myCartRes = useSelector(state => state.carts.myCart)

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        clickStreamUser('cart_page', {
            amount: '',
            userId: auth.authBroker?.payload?.user.user_id,
        })
    }, [dispatch])
    useEffect(() => {
        dispatch(getActiveHeader(""));
       
      }, []);


    return (
        <>
            {/* <Loader start={isLoading} /> */}
            <Page hideFooter={true}>
                <CartSectionComponent />
            </Page>
        </>
    )
}

export default CartPageB2c;